const OrderDetailProductItem = class {
  constructor({ name, unitPrice = 0, quantity = 0}) {
    this.name = name
    this.unitPrice = unitPrice
    this.quantity = quantity
  }
}

export default null

export const ofOrderDetailProductItem = (params = {}) => new OrderDetailProductItem(params)
